// This file is auto-generated by @hey-api/openapi-ts
// @ts-nocheck

import * as z from 'zod/mini';

export const zDeleteApiServicesAssistantsByIdPath = z.object({
    id: z.uuid()
});

/**
 * 204
 */
export const zDeleteApiServicesAssistantsByIdResponse = z.void();

export const zGetApiServicesAssistantsByIdPath = z.object({
    id: z.uuid()
});

/**
 * 200
 */
export const zGetApiServicesAssistantsByIdResponse = z.object({
    id: z.uuid(),
    kindId: z.uuid(),
    name: z.string(),
    description: z.nullable(z.string()),
    isPublished: z.boolean(),
    opco: z.string(),
    systemPrompt: z.string(),
    notes: z.nullable(z.string()),
    question: z.nullable(z.string()),
    knowledgeFiles: z.array(z.object({
        id: z.uuid(),
        fileName: z.nullable(z.string()),
        mediaType: z.enum([
            'application/pdf',
            'text/plain',
            'text/csv'
        ]),
        sizeBytes: z.int(),
        url: z.url(),
        urlExpiresAt: z.iso.datetime()
    })),
    version: z.int(),
    versionCreatedAt: z.string(),
    variables: z.array(z.object({
        name: z.string(),
        type: z.enum(['text', 'select']),
        options: z.optional(z.array(z.string()))
    })),
    permissions: z.object({
        canUpdate: z.boolean(),
        canDelete: z.boolean(),
        canPublish: z.boolean(),
        canUnpublish: z.boolean()
    })
});

/**
 * Body
 */
export const zPatchApiServicesAssistantsByIdBody = z.object({
    name: z.optional(z.string().check(z.minLength(1), z.maxLength(255))),
    description: z.optional(z.string().check(z.maxLength(1000))),
    systemPrompt: z.optional(z.string().check(z.minLength(1), z.maxLength(50000))),
    notes: z.optional(z.string().check(z.maxLength(1000))),
    question: z.optional(z.string().check(z.maxLength(1000))),
    knowledgeFiles: z.optional(z.array(z.union([z.object({
            id: z.uuid()
        }), z.object({
            mediaType: z.enum([
                'application/pdf',
                'text/plain',
                'text/csv'
            ]),
            url: z.string().check(z.minLength(1), z.maxLength(30000000)),
            fileName: z.optional(z.string().check(z.maxLength(255)))
        })])).check(z.maxLength(10)))
});

export const zPatchApiServicesAssistantsByIdPath = z.object({
    id: z.uuid()
});

/**
 * 200
 */
export const zPatchApiServicesAssistantsByIdResponse = z.object({
    id: z.uuid(),
    kindId: z.uuid(),
    name: z.string(),
    description: z.nullable(z.string()),
    isPublished: z.boolean(),
    opco: z.string(),
    systemPrompt: z.string(),
    notes: z.nullable(z.string()),
    question: z.nullable(z.string()),
    knowledgeFiles: z.array(z.object({
        id: z.uuid(),
        fileName: z.nullable(z.string()),
        mediaType: z.enum([
            'application/pdf',
            'text/plain',
            'text/csv'
        ]),
        sizeBytes: z.int(),
        url: z.url(),
        urlExpiresAt: z.iso.datetime()
    })),
    version: z.int(),
    versionCreatedAt: z.string(),
    variables: z.array(z.object({
        name: z.string(),
        type: z.enum(['text', 'select']),
        options: z.optional(z.array(z.string()))
    })),
    permissions: z.object({
        canUpdate: z.boolean(),
        canDelete: z.boolean(),
        canPublish: z.boolean(),
        canUnpublish: z.boolean()
    })
});

export const zGetApiServicesAssistantsQuery = z.object({
    page: z._default(z.optional(z.int().check(z.gte(1))), 1),
    limit: z._default(z.optional(z.int().check(z.gte(1), z.lte(100))), 20),
    isPublished: z.optional(z.union([
        z.boolean(),
        z.string()
    ]))
});

/**
 * 200
 */
export const zGetApiServicesAssistantsResponse = z.object({
    items: z.array(z.object({
        id: z.uuid(),
        kindId: z.uuid(),
        name: z.string(),
        description: z.nullable(z.string()),
        isPublished: z.boolean(),
        opco: z.string(),
        systemPrompt: z.string(),
        notes: z.nullable(z.string()),
        question: z.nullable(z.string()),
        knowledgeFiles: z.array(z.object({
            id: z.uuid(),
            fileName: z.nullable(z.string()),
            mediaType: z.enum([
                'application/pdf',
                'text/plain',
                'text/csv'
            ]),
            sizeBytes: z.int(),
            url: z.url(),
            urlExpiresAt: z.iso.datetime()
        })),
        version: z.int(),
        versionCreatedAt: z.string(),
        variables: z.array(z.object({
            name: z.string(),
            type: z.enum(['text', 'select']),
            options: z.optional(z.array(z.string()))
        })),
        permissions: z.object({
            canUpdate: z.boolean(),
            canDelete: z.boolean(),
            canPublish: z.boolean(),
            canUnpublish: z.boolean()
        })
    })),
    total: z.int(),
    page: z.int(),
    limit: z.int()
});

/**
 * Body
 */
export const zPostApiServicesAssistantsBody = z.object({
    name: z.string().check(z.minLength(1), z.maxLength(255)),
    description: z.optional(z.string().check(z.maxLength(1000))),
    kindId: z.optional(z.uuid()),
    systemPrompt: z.string().check(z.minLength(1), z.maxLength(50000)),
    question: z.optional(z.string().check(z.maxLength(1000))),
    knowledgeFiles: z.optional(z.array(z.object({
        mediaType: z.enum([
            'application/pdf',
            'text/plain',
            'text/csv'
        ]),
        url: z.string().check(z.minLength(1), z.maxLength(30000000)),
        fileName: z.optional(z.string().check(z.maxLength(255)))
    })).check(z.maxLength(10)))
});

/**
 * 201
 */
export const zPostApiServicesAssistantsResponse = z.object({
    id: z.uuid(),
    kindId: z.uuid(),
    name: z.string(),
    description: z.nullable(z.string()),
    isPublished: z.boolean(),
    opco: z.string(),
    systemPrompt: z.string(),
    notes: z.nullable(z.string()),
    question: z.nullable(z.string()),
    knowledgeFiles: z.array(z.object({
        id: z.uuid(),
        fileName: z.nullable(z.string()),
        mediaType: z.enum([
            'application/pdf',
            'text/plain',
            'text/csv'
        ]),
        sizeBytes: z.int(),
        url: z.url(),
        urlExpiresAt: z.iso.datetime()
    })),
    version: z.int(),
    versionCreatedAt: z.string(),
    variables: z.array(z.object({
        name: z.string(),
        type: z.enum(['text', 'select']),
        options: z.optional(z.array(z.string()))
    })),
    permissions: z.object({
        canUpdate: z.boolean(),
        canDelete: z.boolean(),
        canPublish: z.boolean(),
        canUnpublish: z.boolean()
    })
});

export const zPostApiServicesAssistantsByIdPublishPath = z.object({
    id: z.uuid()
});

/**
 * 200
 */
export const zPostApiServicesAssistantsByIdPublishResponse = z.object({
    id: z.uuid(),
    kindId: z.uuid(),
    name: z.string(),
    description: z.nullable(z.string()),
    isPublished: z.boolean(),
    opco: z.string(),
    systemPrompt: z.string(),
    notes: z.nullable(z.string()),
    question: z.nullable(z.string()),
    knowledgeFiles: z.array(z.object({
        id: z.uuid(),
        fileName: z.nullable(z.string()),
        mediaType: z.enum([
            'application/pdf',
            'text/plain',
            'text/csv'
        ]),
        sizeBytes: z.int(),
        url: z.url(),
        urlExpiresAt: z.iso.datetime()
    })),
    version: z.int(),
    versionCreatedAt: z.string(),
    variables: z.array(z.object({
        name: z.string(),
        type: z.enum(['text', 'select']),
        options: z.optional(z.array(z.string()))
    })),
    permissions: z.object({
        canUpdate: z.boolean(),
        canDelete: z.boolean(),
        canPublish: z.boolean(),
        canUnpublish: z.boolean()
    })
});

export const zPostApiServicesAssistantsByIdUnpublishPath = z.object({
    id: z.uuid()
});

/**
 * 200
 */
export const zPostApiServicesAssistantsByIdUnpublishResponse = z.object({
    id: z.uuid(),
    kindId: z.uuid(),
    name: z.string(),
    description: z.nullable(z.string()),
    isPublished: z.boolean(),
    opco: z.string(),
    systemPrompt: z.string(),
    notes: z.nullable(z.string()),
    question: z.nullable(z.string()),
    knowledgeFiles: z.array(z.object({
        id: z.uuid(),
        fileName: z.nullable(z.string()),
        mediaType: z.enum([
            'application/pdf',
            'text/plain',
            'text/csv'
        ]),
        sizeBytes: z.int(),
        url: z.url(),
        urlExpiresAt: z.iso.datetime()
    })),
    version: z.int(),
    versionCreatedAt: z.string(),
    variables: z.array(z.object({
        name: z.string(),
        type: z.enum(['text', 'select']),
        options: z.optional(z.array(z.string()))
    })),
    permissions: z.object({
        canUpdate: z.boolean(),
        canDelete: z.boolean(),
        canPublish: z.boolean(),
        canUnpublish: z.boolean()
    })
});

/**
 * 200
 */
export const zGetApiAuthTokenResponse = z.object({
    token: z.string()
});

/**
 * 200
 */
export const zGetApiAuthCapabilitiesResponse = z.object({
    canManageCollections: z.boolean(),
    canManageAssistantKinds: z.boolean(),
    canPublishAssistants: z.boolean()
});

export const zGetApiServicesChatSessionsQuery = z.object({
    page: z._default(z.optional(z.int().check(z.gte(1))), 1),
    limit: z._default(z.optional(z.int().check(z.gte(1), z.lte(100))), 20),
    assistantId: z.optional(z.uuid()),
    archived: z._default(z.optional(z.enum([
        'all',
        'true',
        'false'
    ])), 'false')
});

/**
 * 200
 */
export const zGetApiServicesChatSessionsResponse = z.object({
    items: z.array(z.object({
        id: z.uuid(),
        assistantId: z.uuid(),
        title: z.nullable(z.string()),
        variables: z.nullable(z.record(z.string(), z.string())),
        archivedAt: z.nullable(z.string()),
        createdAt: z.string()
    })),
    total: z.int(),
    page: z.int(),
    limit: z.int()
});

/**
 * Body
 */
export const zPostApiServicesChatSessionsBody = z.object({
    assistantId: z.uuid(),
    title: z.optional(z.string().check(z.maxLength(255))),
    variables: z.optional(z.record(z.string(), z.string()))
});

/**
 * 201
 */
export const zPostApiServicesChatSessionsResponse = z.object({
    id: z.uuid(),
    assistantId: z.uuid(),
    title: z.nullable(z.string()),
    variables: z.nullable(z.record(z.string(), z.string())),
    archivedAt: z.nullable(z.string()),
    createdAt: z.string()
});

export const zGetApiServicesChatSessionsByIdPath = z.object({
    id: z.uuid()
});

/**
 * 200
 */
export const zGetApiServicesChatSessionsByIdResponse = z.object({
    id: z.uuid(),
    assistantId: z.uuid(),
    title: z.nullable(z.string()),
    variables: z.nullable(z.record(z.string(), z.string())),
    archivedAt: z.nullable(z.string()),
    createdAt: z.string(),
    messages: z.array(z.object({
        id: z.uuid(),
        sessionId: z.uuid(),
        role: z.string(),
        content: z.string(),
        model: z.nullable(z.string()),
        sequence: z.int(),
        createdAt: z.string(),
        files: z.array(z.object({
            id: z.uuid(),
            fileName: z.nullable(z.string()),
            mediaType: z.enum([
                'image/jpeg',
                'image/png',
                'image/gif',
                'image/webp',
                'application/pdf',
                'text/plain',
                'text/csv'
            ]),
            url: z.url(),
            urlExpiresAt: z.iso.datetime()
        }))
    }))
});

/**
 * Body
 */
export const zPatchApiServicesChatSessionsByIdBody = z.object({
    title: z.optional(z.string().check(z.maxLength(255)))
});

export const zPatchApiServicesChatSessionsByIdPath = z.object({
    id: z.uuid()
});

/**
 * 200
 */
export const zPatchApiServicesChatSessionsByIdResponse = z.object({
    id: z.uuid(),
    assistantId: z.uuid(),
    title: z.nullable(z.string()),
    variables: z.nullable(z.record(z.string(), z.string())),
    archivedAt: z.nullable(z.string()),
    createdAt: z.string()
});

export const zPostApiServicesChatSessionsByIdArchivePath = z.object({
    id: z.uuid()
});

/**
 * 200
 */
export const zPostApiServicesChatSessionsByIdArchiveResponse = z.object({
    id: z.uuid(),
    assistantId: z.uuid(),
    title: z.nullable(z.string()),
    variables: z.nullable(z.record(z.string(), z.string())),
    archivedAt: z.nullable(z.string()),
    createdAt: z.string()
});

export const zPostApiServicesChatSessionsByIdUnarchivePath = z.object({
    id: z.uuid()
});

/**
 * 200
 */
export const zPostApiServicesChatSessionsByIdUnarchiveResponse = z.object({
    id: z.uuid(),
    assistantId: z.uuid(),
    title: z.nullable(z.string()),
    variables: z.nullable(z.record(z.string(), z.string())),
    archivedAt: z.nullable(z.string()),
    createdAt: z.string()
});

export const zDeleteApiServicesAssistantcollectionsByIdPath = z.object({
    id: z.uuid()
});

/**
 * 204
 */
export const zDeleteApiServicesAssistantcollectionsByIdResponse = z.void();

export const zGetApiServicesAssistantcollectionsByIdPath = z.object({
    id: z.uuid()
});

/**
 * 200
 */
export const zGetApiServicesAssistantcollectionsByIdResponse = z.object({
    id: z.uuid(),
    name: z.string(),
    description: z.nullable(z.string()),
    isPublic: z.boolean(),
    opco: z.string(),
    assistantCount: z.optional(z.int()),
    followerCount: z.optional(z.int()),
    isFollowing: z.optional(z.boolean()),
    permissions: z.object({
        canUpdate: z.boolean(),
        canDelete: z.boolean(),
        canAddAssistant: z.boolean(),
        canRemoveAssistant: z.boolean()
    })
});

/**
 * Body
 */
export const zPatchApiServicesAssistantcollectionsByIdBody = z.object({
    name: z.optional(z.string().check(z.minLength(1), z.maxLength(255))),
    description: z.optional(z.string().check(z.maxLength(1000))),
    isPublic: z.optional(z.boolean())
});

export const zPatchApiServicesAssistantcollectionsByIdPath = z.object({
    id: z.uuid()
});

/**
 * 200
 */
export const zPatchApiServicesAssistantcollectionsByIdResponse = z.object({
    id: z.uuid(),
    name: z.string(),
    description: z.nullable(z.string()),
    isPublic: z.boolean(),
    opco: z.string(),
    assistantCount: z.optional(z.int()),
    followerCount: z.optional(z.int()),
    isFollowing: z.optional(z.boolean()),
    permissions: z.object({
        canUpdate: z.boolean(),
        canDelete: z.boolean(),
        canAddAssistant: z.boolean(),
        canRemoveAssistant: z.boolean()
    })
});

export const zGetApiServicesAssistantcollectionsQuery = z.object({
    page: z._default(z.optional(z.int().check(z.gte(1))), 1),
    limit: z._default(z.optional(z.int().check(z.gte(1), z.lte(100))), 20),
    ownedBy: z.optional(z.string()),
    onlyFollowed: z.nullish(z.boolean())
});

/**
 * 200
 */
export const zGetApiServicesAssistantcollectionsResponse = z.object({
    items: z.array(z.object({
        id: z.uuid(),
        name: z.string(),
        description: z.nullable(z.string()),
        isPublic: z.boolean(),
        opco: z.string(),
        assistantCount: z.optional(z.int()),
        followerCount: z.optional(z.int()),
        isFollowing: z.optional(z.boolean()),
        permissions: z.object({
            canUpdate: z.boolean(),
            canDelete: z.boolean(),
            canAddAssistant: z.boolean(),
            canRemoveAssistant: z.boolean()
        })
    })),
    total: z.int(),
    page: z.int(),
    limit: z.int()
});

/**
 * Body
 */
export const zPostApiServicesAssistantcollectionsBody = z.object({
    name: z.string().check(z.minLength(1), z.maxLength(255)),
    description: z.optional(z.string().check(z.maxLength(1000))),
    isPublic: z._default(z.optional(z.boolean()), false)
});

/**
 * 201
 */
export const zPostApiServicesAssistantcollectionsResponse = z.object({
    id: z.uuid(),
    name: z.string(),
    description: z.nullable(z.string()),
    isPublic: z.boolean(),
    opco: z.string(),
    assistantCount: z.optional(z.int()),
    followerCount: z.optional(z.int()),
    isFollowing: z.optional(z.boolean()),
    permissions: z.object({
        canUpdate: z.boolean(),
        canDelete: z.boolean(),
        canAddAssistant: z.boolean(),
        canRemoveAssistant: z.boolean()
    })
});

export const zGetApiServicesAssistantcollectionsByIdAssistantsPath = z.object({
    id: z.uuid()
});

export const zGetApiServicesAssistantcollectionsByIdAssistantsQuery = z.object({
    page: z._default(z.optional(z.int().check(z.gte(1))), 1),
    limit: z._default(z.optional(z.int().check(z.gte(1), z.lte(100))), 20)
});

/**
 * 200
 */
export const zGetApiServicesAssistantcollectionsByIdAssistantsResponse = z.object({
    items: z.array(z.object({
        id: z.uuid(),
        kindId: z.uuid(),
        name: z.string(),
        description: z.nullable(z.string()),
        isPublished: z.boolean(),
        opco: z.string()
    })),
    total: z.int(),
    page: z.int(),
    limit: z.int()
});

/**
 * Body
 */
export const zPostApiServicesAssistantcollectionsByIdAssistantsBody = z.object({
    assistantIds: z.array(z.uuid()).check(z.minLength(1))
});

export const zPostApiServicesAssistantcollectionsByIdAssistantsPath = z.object({
    id: z.uuid()
});

/**
 * 200
 */
export const zPostApiServicesAssistantcollectionsByIdAssistantsResponse = z.object({
    added: z.int()
});

export const zDeleteApiServicesAssistantcollectionsByIdAssistantsByAssistantIdPath = z.object({
    id: z.uuid(),
    assistantId: z.uuid()
});

/**
 * 204
 */
export const zDeleteApiServicesAssistantcollectionsByIdAssistantsByAssistantIdResponse = z.void();

export const zDeleteApiServicesAssistantcollectionsByIdFollowPath = z.object({
    id: z.uuid()
});

/**
 * 200
 */
export const zDeleteApiServicesAssistantcollectionsByIdFollowResponse = z.object({
    unfollowed: z.boolean()
});

export const zPostApiServicesAssistantcollectionsByIdFollowPath = z.object({
    id: z.uuid()
});

/**
 * 200
 */
export const zPostApiServicesAssistantcollectionsByIdFollowResponse = z.object({
    following: z.boolean()
});

export const zDeleteApiServicesAssistantkindsByIdPath = z.object({
    id: z.uuid()
});

/**
 * 204
 */
export const zDeleteApiServicesAssistantkindsByIdResponse = z.void();

export const zGetApiServicesAssistantkindsByIdPath = z.object({
    id: z.uuid()
});

/**
 * 200
 */
export const zGetApiServicesAssistantkindsByIdResponse = z.object({
    id: z.uuid(),
    surrogateName: z.string(),
    name: z.string()
});

/**
 * Body
 */
export const zPatchApiServicesAssistantkindsByIdBody = z.object({
    surrogateName: z.optional(z.string().check(z.minLength(1), z.maxLength(255))),
    name: z.optional(z.string().check(z.minLength(1), z.maxLength(255)))
});

export const zPatchApiServicesAssistantkindsByIdPath = z.object({
    id: z.uuid()
});

/**
 * 200
 */
export const zPatchApiServicesAssistantkindsByIdResponse = z.object({
    id: z.uuid(),
    surrogateName: z.string(),
    name: z.string()
});

/**
 * 200
 */
export const zGetApiServicesAssistantkindsResponse = z.array(z.object({
    id: z.uuid(),
    surrogateName: z.string(),
    name: z.string()
}));

/**
 * Body
 */
export const zPostApiServicesAssistantkindsBody = z.object({
    surrogateName: z.string().check(z.minLength(1), z.maxLength(255)),
    name: z.string().check(z.minLength(1), z.maxLength(255))
});

/**
 * 201
 */
export const zPostApiServicesAssistantkindsResponse = z.object({
    id: z.uuid(),
    surrogateName: z.string(),
    name: z.string()
});

export const zPostApiServicesChatCompletionsBody = z.object({
    assistantId: z.uuid(),
    sessionId: z.optional(z.uuid()),
    messages: z.array(z.object({
        role: z.enum(['user', 'assistant']),
        content: z.string().check(z.minLength(1), z.maxLength(100000))
    })).check(z.minLength(1), z.maxLength(100))
});

/**
 * Streaming text response
 */
export const zPostApiServicesChatCompletionsResponse = z.string();
